import { ShieldCheck, ClipboardCheck, Wallet, BarChart3, Building2, Eye, Store, ScanLine, Plug, ChartLine } from 'lucide-react';

export const DEMO_ROLES = [
  { role: 'ops_admin', name: 'OPS Admin', icon: ShieldCheck },
  { role: 'ops_reviewer', name: 'OPS Reviewer', icon: ClipboardCheck },
  { role: 'ops_finance', name: 'OPS Finance', icon: Wallet },
  { role: 'ops_manager', name: 'OPS Manager', icon: BarChart3 },
  { role: 'sponsor_admin', name: 'Sponsor Admin', icon: Building2 },
  { role: 'sponsor_viewer', name: 'Sponsor Viewer', icon: Eye },
  { role: 'merchant_admin', name: 'Merchant Admin', icon: Store },
  { role: 'merchant_cashier', name: 'Merchant Cashier', icon: ScanLine },
  { role: 'app_admin', name: 'App Admin', icon: Plug },
  { role: 'app_viewer', name: 'App Viewer', icon: ChartLine },
] as const;
